import { useEffect, useState } from 'react';

import { resolveWorkspaceBlobFromCacheOrRemote } from '../utils/blob-cache';

export function useWorkspaceBlobObjectUrl(
  workspaceId: string | null | undefined,
  blobId: string | null | undefined
): string | null {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    let nextObjectUrl: string | null = null;
    setObjectUrl(null);

    if (!workspaceId || !blobId) return;

    void resolveWorkspaceBlobFromCacheOrRemote({
      workspaceId,
      key: blobId,
    })
      .then(blob => {
        if (!blob || cancelled) return;
        nextObjectUrl = URL.createObjectURL(blob);
        setObjectUrl(nextObjectUrl);
      })
      .catch(() => undefined);

    return () => {
      cancelled = true;
      if (nextObjectUrl) URL.revokeObjectURL(nextObjectUrl);
    };
  }, [blobId, workspaceId]);

  return objectUrl;
}
